import React from 'react';
import { Button, Modal, ModalHeader, ModalFooter, ModalBody  } from 'reactstrap';
import { withAlert } from 'react-alert'
import { connect } from 'react-redux'

class DeleteDocumentTypeConfigModal extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            ...props
        }

        this.attemptDelete = this.attemptDelete.bind(this) 
    }

    attemptDelete() 
    {
      //Set document to status deleted in archive
      fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentType?id='+this.props.destination,{
        method: 'DELETE'
      })
      .then(result => 
      {
        this.props.refresh()
        this.props.toggle()
        this.props.alert.success("Deleted document type.");
      })
      .catch(error=>
      {
        //need to log the error
        this.props.alert.error('An error occurred whilst attemping document type deletion ' + error);
        
      });
    }

    render() {

        const { localisation } = this.props.userReducer;

        return (
            <Modal isOpen={this.props.modal} toggle={this.props.toggle} className='modal-dialog'>
                <ModalHeader toggle={this.props.toggle}>{localisation['delete_document_config_header'] ? localisation['delete_document_config_header'].element_lang : ''}</ModalHeader>
                <ModalBody>
                  {localisation['delete_document_config_confirmation_text'] ? localisation['delete_document_config_confirmation_text'].element_lang +': ' + this.props.name +'?' : '' + this.props.name}
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={this.attemptDelete}>Delete</Button>
                    <Button id="cancelButton" color="secondary" onClick={this.props.toggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default connect(state => state)(withAlert()(DeleteDocumentTypeConfigModal));